export default __webpack_public_path__ + "static/media/nav-bars.a66c9d6f.svg";